export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST'
export const FETCH_USER_SECCESS = 'FETCH_USER_SECCESS'
export const FETCH_USER_EXISTS = 'FETCH_USER_EXISTS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'